import { render, staticRenderFns } from "./shopactivities.vue?vue&type=template&id=5f680def&scoped=true"
import script from "./shopactivities.vue?vue&type=script&lang=js"
export * from "./shopactivities.vue?vue&type=script&lang=js"
import style0 from "./shopactivities.vue?vue&type=style&index=0&id=5f680def&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f680def",
  null
  
)

export default component.exports